/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const HeartFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="heart-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M719.4966666666666 1058.76A304.8666666666667 304.8666666666667 0 0 0 1156.3966666666665 1058.6466666666668C1276.7566666666664 935.9066666666668 1276.7566666666664 737.0066666666667 1156.3966666666665 614.2666666666667L1155.83 613.6433333333334L680 168.6966666666667L204.2266666666667 613.7L203.66 614.2666666666667C83.2433333333334 737.0633333333334 83.2433333333334 935.9633333333334 203.66 1058.7033333333334A304.8666666666667 304.8666666666667 0 0 0 640.5033333333333 1058.8166666666666L680 1019.15L719.4966666666666 1058.8166666666666z" : "M575.5973333333334 847.008A243.8933333333334 243.8933333333334 0 0 0 925.1173333333334 846.9173333333333C1021.4053333333334 748.7253333333333 1021.4053333333334 589.6053333333333 925.1173333333334 491.4133333333333L924.664 490.9146666666667L544 134.9573333333333L163.3813333333334 490.9599999999999L162.928 491.4133333333333C66.5946666666667 589.6506666666667 66.5946666666667 748.7706666666666 162.928 846.9626666666667A243.8933333333334 243.8933333333334 0 0 0 512.4026666666667 847.0533333333333L544 815.3199999999999L575.5973333333334 847.0533333333333z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
HeartFilled.displayName = `Blueprint5.Icon.HeartFilled`;
export default HeartFilled;
